import React , {useContext} from "react";
import { Link,useLocation } from 'react-router-dom';
import Context from './context/context';
import Lang from './lang/translations';

import * as config from "./_helpers/configServizi";





export default function Footer() {

    const domain = window.location.hostname;
  
    const context = useContext(Context)

    var location = useLocation();

    if(context.fluxId === "0000" && location[1] == "chats"){
        return (<div className="footer d-lg-block">
            <div className="mb-0">
            <div className="mb-0">
                <nav>

                        {config.servizi[domain].legal_link.faq.startsWith("https://") && <>
                            <Link target="_blank" to={config.servizi[domain].legal_link.faq}><Lang w={"faq"} page={"footer"} /></Link>
                            <Link target="_blank" to={config.servizi[domain].legal_link.termini}><Lang w={"termini"} page={"footer"} /></Link>
                            <Link target="_blank" to={config.servizi[domain].legal_link.privacy}><Lang w={"privacy"} page={"footer"} /></Link>
                            <Link target="_blank" to={config.servizi[domain].legal_link.cookie}><Lang w={"cookie"} page={"footer"} /></Link>
                            <Link target="_blank" to={config.servizi[domain].legal_link.contatti}><Lang w={"contact_us"} page={"footer"} /></Link>
                    </>}
                </nav>
            </div>
            <img className="creditCardFlags" src="/img/credit-card-icons.png" border="0" />
            <p className="font-08 mb-0">{config.servizi[domain].title} &copy; - {config.servizi[domain].anno} </p>
        </div>

       

        </div>)
    }
   
    else{ 
        return <div></div> 
     }
   

}

